document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  const hasFinePointer = window.matchMedia(
    '(pointer: fine)'
  ).matches;

  const hasGSAP =
    typeof gsap !== 'undefined' &&
    typeof ScrollTrigger !== 'undefined';

  if (hasGSAP) {
    gsap.registerPlugin(ScrollTrigger);
  }

  const useCustomCursor = hasFinePointer && !reduceMotion;
  const useParticles = !reduceMotion;

  if (useCustomCursor) {
    document.body.classList.add('has-custom-cursor');
  }

  if (useParticles) {
    document.body.classList.add('has-particles');
  }

  const yearEl = document.getElementById('year');

  if (yearEl) {
    yearEl.textContent = new Date().getFullYear();
  }

  const marqueeTrack = document.querySelector('.marquee-track');

  if (marqueeTrack) {
    marqueeTrack.innerHTML += marqueeTrack.innerHTML;
  }

  /* =========================================================
     PRELOADER
     ========================================================= */

  const preloader = document.getElementById('preloader');

  let siteRevealed = false;

  function revealSite() {
    if (siteRevealed) return;

    siteRevealed = true;

    if (preloader) {
      preloader.classList.add('is-hidden');
    }

    document.body.classList.add('is-loaded');
    startHeroReveal();
  }

  const hardTimeout = setTimeout(revealSite, 2500);

  setTimeout(() => {
    clearTimeout(hardTimeout);
    revealSite();
  }, 900);

  /* =========================================================
     LENIS — SCROLL SUAVE
     ========================================================= */

  let lenis = null;

  if (typeof Lenis !== 'undefined' && !reduceMotion) {
    lenis = new Lenis({
      duration: 1.45,
      easing: (t) => 1 - Math.pow(1 - t, 4),
      smoothWheel: true,
      wheelMultiplier: 0.78,
      touchMultiplier: 0.9
    });

    function raf(time) {
      lenis.raf(time);

      if (hasGSAP) {
        ScrollTrigger.update();
      }

      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }

  /* =========================================================
     BARRA DE PROGRESO
     ========================================================= */

  const scrollProgress = document.getElementById('scroll-progress');

  function updateScrollProgress() {
    const html = document.documentElement;
    const body = document.body;

    const scrolled = html.scrollTop || body.scrollTop;
    const scrollHeight = html.scrollHeight - html.clientHeight;
    const percentage =
      scrollHeight > 0
        ? (scrolled / scrollHeight) * 100
        : 0;

    if (scrollProgress) {
      scrollProgress.style.width = `${percentage}%`;
    }
  }

  window.addEventListener(
    'scroll',
    updateScrollProgress,
    { passive: true }
  );

  if (lenis) {
    lenis.on('scroll', updateScrollProgress);
  }

  /* =========================================================
     STICKY MOBILE BAR
     ========================================================= */

  const stickyBar = document.getElementById(
    'sticky-mobile-bar'
  );

  const heroElement = document.getElementById('hero');

  if (stickyBar && heroElement) {
    const heroObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          stickyBar.classList.toggle(
            'is-visible',
            !entry.isIntersecting
          );
        });
      },
      { threshold: 0 }
    );

    heroObserver.observe(heroElement);
  }

  /* =========================================================
     CURSOR PERSONALIZADO
     ========================================================= */

  const cursorDot = document.getElementById('cursor-dot');
  const cursorRing = document.getElementById('cursor-ring');
  const spotlight = document.getElementById('cursor-spotlight');

  if (useCustomCursor) {
    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let ringX = mouseX;
    let ringY = mouseY;

    window.addEventListener('mousemove', (event) => {
      mouseX = event.clientX;
      mouseY = event.clientY;

      if (cursorDot) {
        cursorDot.style.left = `${mouseX}px`;
        cursorDot.style.top = `${mouseY}px`;
      }

      if (spotlight) {
        spotlight.style.transform =
          `translate(${mouseX}px, ${mouseY}px)`;
      }
    });

    function animateCursorRing() {
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;

      if (cursorRing) {
        cursorRing.style.left = `${ringX}px`;
        cursorRing.style.top = `${ringY}px`;
      }

      requestAnimationFrame(animateCursorRing);
    }

    animateCursorRing();

    document
      .querySelectorAll('a, button, input, textarea')
      .forEach((element) => {
        element.addEventListener('mouseenter', () => {
          if (cursorRing) {
            cursorRing.classList.add('is-active');
          }
        });

        element.addEventListener('mouseleave', () => {
          if (cursorRing) {
            cursorRing.classList.remove('is-active');
          }
        });
      });
  }

  /* =========================================================
     PARTÍCULAS DEL HERO
     ========================================================= */

  const canvas = document.getElementById('hero-canvas');
  const heroSection = document.getElementById('hero');

  if (canvas && heroSection && useParticles) {
    const context = canvas.getContext('2d');

    let particles = [];
    let animationFrame = null;
    let heroVisible = true;

    const pointer = {
      x: -9999,
      y: -9999
    };

    function resizeCanvas() {
      const pixelRatio = Math.min(
        window.devicePixelRatio || 1,
        2
      );

      const width = heroSection.offsetWidth;
      const height = heroSection.offsetHeight;

      canvas.width = width * pixelRatio;
      canvas.height = height * pixelRatio;
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;

      context.setTransform(
        pixelRatio,
        0,
        0,
        pixelRatio,
        0,
        0
      );

      const isMobile = window.innerWidth <= 760;

      const particleCount = isMobile
        ? 75
        : Math.min(
            150,
            Math.max(
              100,
              Math.floor((width * height) / 10500)
            )
          );

      particles = Array.from(
        { length: particleCount },
        () => ({
          x: Math.random() * width,
          y: Math.random() * height,

          vx:
            (Math.random() - 0.5) *
            (isMobile ? 0.55 : 0.45),

          vy:
            (Math.random() - 0.5) *
            (isMobile ? 0.55 : 0.45),

          radius: isMobile
            ? Math.random() * 2.4 + 1
            : Math.random() * 2.2 + 0.8,

          gold: Math.random() > 0.25
        })
      );
    }

    function resetPointer() {
      pointer.x = -9999;
      pointer.y = -9999;
    }

    heroSection.addEventListener(
      'mousemove',
      (event) => {
        const rect = heroSection.getBoundingClientRect();

        pointer.x = event.clientX - rect.left;
        pointer.y = event.clientY - rect.top;
      }
    );

    heroSection.addEventListener(
      'mouseleave',
      resetPointer
    );

    function drawParticles() {
      if (!heroVisible) {
        animationFrame = null;
        return;
      }

      const width = heroSection.offsetWidth;
      const height = heroSection.offsetHeight;

      context.clearRect(0, 0, width, height);

      particles.forEach((particle) => {
        particle.x += particle.vx;
        particle.y += particle.vy;

        if (
          particle.x < -10 ||
          particle.x > width + 10
        ) {
          particle.vx *= -1;
        }

        if (
          particle.y < -10 ||
          particle.y > height + 10
        ) {
          particle.vy *= -1;
        }

        const distanceX = pointer.x - particle.x;
        const distanceY = pointer.y - particle.y;

        const distance = Math.sqrt(
          distanceX * distanceX +
          distanceY * distanceY
        );

        if (distance < 160) {
          particle.x -= distanceX * 0.012;
          particle.y -= distanceY * 0.012;
        }

        context.beginPath();

        context.fillStyle = particle.gold
          ? 'rgba(244,227,176,1)'
          : 'rgba(199,196,188,0.75)';

        context.shadowBlur = particle.gold ? 10 : 5;
        context.shadowColor = particle.gold
          ? 'rgba(217,178,94,0.65)'
          : 'rgba(199,196,188,0.35)';

        context.arc(
          particle.x,
          particle.y,
          particle.radius,
          0,
          Math.PI * 2
        );

        context.fill();
        context.shadowBlur = 0;
      });

      for (let first = 0; first < particles.length; first++) {
        for (
          let second = first + 1;
          second < particles.length;
          second++
        ) {
          const particleA = particles[first];
          const particleB = particles[second];

          const distanceX =
            particleA.x - particleB.x;

          const distanceY =
            particleA.y - particleB.y;

          const distance = Math.sqrt(
            distanceX * distanceX +
            distanceY * distanceY
          );

          if (distance < 155) {
            const opacity = 0.3 *
              (1 - distance / 155);

            context.beginPath();
            context.strokeStyle =
              `rgba(217,178,94,${opacity})`;

            context.lineWidth = 1;
            context.moveTo(
              particleA.x,
              particleA.y
            );

            context.lineTo(
              particleB.x,
              particleB.y
            );

            context.stroke();
          }
        }
      }

      animationFrame = requestAnimationFrame(
        drawParticles
      );
    }

    resizeCanvas();
    drawParticles();

    window.addEventListener(
      'resize',
      resizeCanvas,
      { passive: true }
    );

    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        heroVisible = entries[0].isIntersecting;

        if (heroVisible && !animationFrame) {
          drawParticles();
        }
      },
      { threshold: 0 }
    );

    visibilityObserver.observe(heroSection);
  }

  /* =========================================================
     ENTRADA DEL HERO
     ========================================================= */

  function startHeroReveal() {
    const titleLines = document.querySelectorAll(
      '.mask-line-inner'
    );

    const fadeElements = document.querySelectorAll(
      '[data-fade]'
    );

    if (!hasGSAP || reduceMotion) {
      titleLines.forEach((line) => {
        line.style.transform = 'translateY(0)';
      });

      fadeElements.forEach((element) => {
        element.style.opacity = '1';
        element.style.transform = 'translateY(0)';
      });

      return;
    }

    gsap.to(titleLines, {
      y: 0,
      duration: 0.85,
      ease: 'power4.out',
      stagger: 0.09
    });

    gsap.to(fadeElements, {
      opacity: 1,
      y: 0,
      duration: 0.7,
      ease: 'power2.out',
      stagger: 0.12,
      delay: 0.45
    });
  }

  /* =========================================================
     REVEALS AL HACER SCROLL
     ========================================================= */

  if (hasGSAP) {
    document
      .querySelectorAll('.reveal-title')
      .forEach((element) => {
        gsap.fromTo(
          element,
          {
            opacity: 0,
            y: 20
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: element,
              start: 'top 85%'
            }
          }
        );
      });

    const groups = new Map();

    document
      .querySelectorAll('.reveal-stagger')
      .forEach((element) => {
        const parent = element.parentElement;

        if (!groups.has(parent)) {
          groups.set(parent, []);
        }

        groups.get(parent).push(element);
      });

    groups.forEach((elements, parent) => {
      gsap.fromTo(
        elements,
        {
          opacity: 0,
          y: 20
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.55,
          ease: 'power2.out',
          stagger: 0.08,
          scrollTrigger: {
            trigger: parent,
            start: 'top 82%'
          }
        }
      );
    });
  } else {
    document
      .querySelectorAll('.reveal-title, .reveal-stagger')
      .forEach((element) => {
        element.classList.add('is-visible');
      });
  }

  /* =========================================================
     PARALLAX
     ========================================================= */

  if (hasGSAP) {
    const parallaxMedia = gsap.matchMedia();

    parallaxMedia.add(
      {
        desktop: '(min-width: 761px)',
        mobile: '(max-width: 760px)'
      },
      (context) => {
        const isDesktop = context.conditions.desktop;

        const glowDistance = isDesktop ? 170 : 35;
        const canvasDistance = isDesktop ? 90 : 22;
        const glowScale = isDesktop ? 1.18 : 1.03;
        const mediaDistance = isDesktop ? 45 : 8;

        const heroGlow = document.querySelector(
          '.hero-glow'
        );

        if (heroGlow) {
          gsap.to(heroGlow, {
            y: glowDistance,
            scale: glowScale,
            ease: 'none',
            scrollTrigger: {
              trigger: '#hero',
              start: 'top top',
              end: 'bottom top',
              scrub: 0.8
            }
          });
        }

        const heroCanvas = document.querySelector(
          '.hero-canvas'
        );

        if (heroCanvas) {
          gsap.to(heroCanvas, {
            y: canvasDistance,
            ease: 'none',
            scrollTrigger: {
              trigger: '#hero',
              start: 'top top',
              end: 'bottom top',
              scrub: 1
            }
          });
        }

        gsap.utils
          .toArray('.solution-media')
          .forEach((media) => {
            const card = media.closest(
              '.solution-card'
            );

            gsap.fromTo(
              media,
              {
                y: -mediaDistance
              },
              {
                y: mediaDistance,
                ease: 'none',
                scrollTrigger: {
                  trigger: card || media,
                  start: 'top bottom',
                  end: 'bottom top',
                  scrub: 0.8
                }
              }
            );
          });

        const trustStatement = document.querySelector(
          '.trust-statement'
        );

        if (trustStatement) {
          gsap.fromTo(
            trustStatement,
            {
              y: isDesktop ? 35 : 18
            },
            {
              y: isDesktop ? -35 : -18,
              ease: 'none',
              scrollTrigger: {
                trigger: '.trust-after-process',
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1
              }
            }
          );
        }

        gsap.utils
          .toArray('.process-steps .step')
          .forEach((step, index) => {
            const direction =
              index % 2 === 0 ? -1 : 1;

            gsap.to(step, {
              y: direction *
                (isDesktop ? 22 : 10),
              ease: 'none',
              scrollTrigger: {
                trigger: '#proceso',
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1.2
              }
            });
          });
      }
    );
  }

  /* =========================================================
     INCLINACIÓN 3D DE TARJETAS
     ========================================================= */

  if (hasFinePointer && !reduceMotion) {
    document
      .querySelectorAll('.solution-card')
      .forEach((card) => {
        card.addEventListener('mousemove', (event) => {
          const rect = card.getBoundingClientRect();

          const x =
            event.clientX - rect.left;

          const y =
            event.clientY - rect.top;

          const rotateX =
            ((y - rect.height / 2) /
              (rect.height / 2)) *
            -5;

          const rotateY =
            ((x - rect.width / 2) /
              (rect.width / 2)) *
            5;

          card.style.transform =
            `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-4px)`;
        });

        card.addEventListener('mouseleave', () => {
          card.style.transform = '';
        });
      });
  }

  /* =========================================================
     LÍNEA DEL PROCESO
     ========================================================= */

  const processFill = document.getElementById(
    'process-line-fill'
  );

  if (hasGSAP && processFill) {
    gsap.to(processFill, {
      width: '100%',
      ease: 'none',
      scrollTrigger: {
        trigger: '.process-steps',
        start: 'top 70%',
        end: 'bottom 60%',
        scrub: true
      }
    });
  }

  /* =========================================================
     MENÚ MÓVIL
     ========================================================= */

  const navToggle = document.getElementById(
    'nav-toggle'
  );

  const mainNav = document.getElementById(
    'main-nav'
  );

  if (navToggle && mainNav) {
    let navScrim = document.querySelector(
      '.nav-scrim'
    );

    if (!navScrim) {
      navScrim = document.createElement('div');
      navScrim.className = 'nav-scrim';
      document.body.appendChild(navScrim);
    }

    function openNav() {
      mainNav.classList.add('is-open');
      navScrim.classList.add('is-visible');
      navToggle.setAttribute(
        'aria-expanded',
        'true'
      );
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      mainNav.classList.remove('is-open');
      navScrim.classList.remove('is-visible');
      navToggle.setAttribute(
        'aria-expanded',
        'false'
      );
      document.body.style.overflow = '';
    }

    navToggle.addEventListener('click', () => {
      const isOpen =
        mainNav.classList.contains('is-open');

      if (isOpen) {
        closeNav();
      } else {
        openNav();
      }
    });

    navScrim.addEventListener('click', closeNav);

    mainNav
      .querySelectorAll('a')
      .forEach((link) => {
        link.addEventListener('click', closeNav);
      });

    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        mainNav.classList.contains('is-open')
      ) {
        closeNav();
      }
    });
  }

  /* =========================================================
     FORMULARIO PRINCIPAL
     ========================================================= */

  const form = document.getElementById(
    'contact-form'
  );

  const confirmation = document.getElementById(
    'form-confirmation'
  );

  if (form && confirmation) {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const nombre = form.querySelector(
        '[name="contact[name]"]'
      );

      const empresa = form.querySelector(
        '[name="contact[Empresa]"]'
      );

      const objetivo = form.querySelector(
        '[name="contact[Objetivo]"]'
      );

      const contacto = form.querySelector(
        '[name="contact[email]"]'
      );

      const valid =
        nombre &&
        empresa &&
        objetivo &&
        contacto &&
        nombre.value.trim() &&
        empresa.value.trim() &&
        objetivo.value.trim() &&
        contacto.value.trim();

      if (!valid) {
        return;
      }

      form.reset();
      form.hidden = true;
      confirmation.hidden = false;

      confirmation.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    });
  }

  /* =========================================================
     MODAL EXIT INTENT
     ========================================================= */

  const isTouch = !hasFinePointer;

  const exitModal = document.getElementById(
    'exit-modal'
  );

  const exitBackdrop = document.getElementById(
    'exit-modal-backdrop'
  );

  const exitClose = document.getElementById(
    'exit-modal-close'
  );

  const exitCta = document.getElementById(
    'exit-modal-cta'
  );

  let exitShown =
    sessionStorage.getItem(
      'lutzardo_exit_shown'
    ) === '1';

  let exitArmed = false;

  setTimeout(() => {
    exitArmed = true;
  }, 8000);

  window.addEventListener(
    'scroll',
    () => {
      const currentScroll =
        window.scrollY ||
        document.documentElement.scrollTop;

      if (currentScroll > 300) {
        exitArmed = true;
      }
    },
    { passive: true }
  );

  function openExitModal() {
    if (
      exitShown ||
      !exitArmed ||
      isTouch ||
      !exitModal
    ) {
      return;
    }

    exitShown = true;

    sessionStorage.setItem(
      'lutzardo_exit_shown',
      '1'
    );

    exitModal.hidden = false;

    requestAnimationFrame(() => {
      exitModal.classList.add('is-active');
    });
  }

  function closeExitModal() {
    if (!exitModal) {
      return;
    }

    exitModal.classList.remove('is-active');

    setTimeout(() => {
      exitModal.hidden = true;
    }, 300);
  }

  if (!isTouch) {
    document.addEventListener(
      'mouseleave',
      (event) => {
        if (event.clientY <= 0) {
          openExitModal();
        }
      }
    );
  }

  if (exitBackdrop) {
    exitBackdrop.addEventListener(
      'click',
      closeExitModal
    );
  }

  if (exitClose) {
    exitClose.addEventListener(
      'click',
      closeExitModal
    );
  }

  if (exitCta) {
    exitCta.addEventListener(
      'click',
      closeExitModal
    );
  }

  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Escape' &&
      exitModal &&
      !exitModal.hidden
    ) {
      closeExitModal();
    }
  });

  updateScrollProgress();
});

document.addEventListener('DOMContentLoaded', function () {
  const confirmation = document.querySelector('#form-confirmation');

  if (!confirmation) return;

  const params = new URLSearchParams(window.location.search);
  const hasFormSuccess = params.has('contact_posted');

  if (!hasFormSuccess) {
    confirmation.style.display = 'none';
  }
});

(function () {
  function initLutzardoHeader() {
    var toggle = document.getElementById('nav-toggle');
    var nav = document.getElementById('main-nav');

    if (!toggle || !nav || toggle.dataset.lutzardoReady === 'true') return;
    toggle.dataset.lutzardoReady = 'true';

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.setAttribute('aria-label', open ? 'Abrir menú' : 'Cerrar menú');
      nav.classList.toggle('is-open', !open);
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Abrir menú');
        nav.classList.remove('is-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLutzardoHeader);
  } else {
    initLutzardoHeader();
  }
})();


/* Menú móvil Lutzardo: compatible con página principal y páginas internas */
(function () {
  function initLutzardoMobileMenu() {
    var buttons = document.querySelectorAll('#nav-toggle, .nav-toggle, .lz-shared-toggle');

    buttons.forEach(function (button) {
      if (button.dataset.lutzardoMenuReady === 'true') return;
      button.dataset.lutzardoMenuReady = 'true';

      var navId = button.getAttribute('aria-controls') || 'main-nav';
      var nav = document.getElementById(navId) || document.querySelector('.main-nav, .lz-shared-nav');
      if (!nav) return;

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        button.setAttribute('aria-label', isOpen ? 'Abrir menú' : 'Cerrar menú');
        nav.classList.toggle('is-open', !isOpen);
        nav.classList.toggle('open', !isOpen);
        nav.classList.toggle('active', !isOpen);
      });

      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-label', 'Abrir menú');
          nav.classList.remove('is-open', 'open', 'active');
        });
      });
    });

    document.addEventListener('click', function (event) {
      buttons.forEach(function (button) {
        var navId = button.getAttribute('aria-controls') || 'main-nav';
        var nav = document.getElementById(navId) || document.querySelector('.main-nav, .lz-shared-nav');
        if (!nav || !nav.classList.contains('is-open')) return;
        if (!nav.contains(event.target) && !button.contains(event.target)) {
          button.setAttribute('aria-expanded', 'false');
          nav.classList.remove('is-open', 'open', 'active');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLutzardoMobileMenu);
  } else {
    initLutzardoMobileMenu();
  }
})();